/**
 * REPUTE Wishlist / Bookmark System
 * localStorage-based, works for guests and logged-in users
 */
(function () {
  'use strict';

  const STORAGE_KEY = 'rpt_wishlist';
  const EVENT_CHANGED = 'repute:wishlist:changed';

  class ReputeWishlist {
    constructor() {
      this._items = this._load();
      this._bindEvents();
      this._syncUI();
    }

    /* ── Storage ── */

    _load() {
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        return raw ? JSON.parse(raw) : [];
      } catch (e) {
        return [];
      }
    }

    _save() {
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(this._items));
      } catch (e) {
        /* storage full — silent fail */
      }
      document.dispatchEvent(new CustomEvent(EVENT_CHANGED, { detail: { items: this._items } }));
      this._syncUI();
    }

    /* ── Public API ── */

    add(handle) {
      if (!handle || this.has(handle)) return;
      this._items.push(handle);
      this._save();
    }

    remove(handle) {
      const idx = this._items.indexOf(handle);
      if (idx === -1) return;
      this._items.splice(idx, 1);
      this._save();
    }

    toggle(handle) {
      this.has(handle) ? this.remove(handle) : this.add(handle);
    }

    has(handle) {
      return this._items.indexOf(handle) !== -1;
    }

    getAll() {
      return this._items.slice();
    }

    count() {
      return this._items.length;
    }

    /* ── UI Sync ── */

    _syncUI() {
      /* Update all bookmark buttons */
      document.querySelectorAll('[data-rpt-bookmark]').forEach(function (btn) {
        var handle = btn.getAttribute('data-product-handle');
        if (!handle) return;
        btn.classList.toggle('is-saved', this.has(handle));
        btn.setAttribute('aria-pressed', this.has(handle) ? 'true' : 'false');
      }.bind(this));

      /* Update header counter */
      var c = this.count();
      document.querySelectorAll('[data-rpt-wishlist-count]').forEach(function (el) {
        var isText = el.closest('.rpt-header__wishlist--text');
        if (isText) {
          el.textContent = c > 0 ? ' (' + c + ')' : '';
          el.style.display = c > 0 ? '' : 'none';
        } else {
          el.textContent = c;
          el.style.display = c > 0 ? '' : 'none';
        }
      });
    }

    /* ── Click delegation ── */

    _bindEvents() {
      var self = this;

      document.addEventListener('click', function (e) {
        var btn = e.target.closest('[data-rpt-bookmark]');
        if (!btn) return;
        e.preventDefault();
        e.stopPropagation();
        var handle = btn.getAttribute('data-product-handle');
        if (handle) self.toggle(handle);
      });

      /* Re-sync when DOM changes (e.g., AJAX collection load) */
      document.addEventListener('repute:wishlist:changed', function () {});
    }
  }

  /* Initialise on DOM ready */
  function init() {
    window.ReputeWishlist = new ReputeWishlist();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
